import React from 'react'
import Academic from "./images/Academic";
import Alcohol from "./images/Alcohol";
import Anxiety from "./images/Anxiety";
import Breakups from "./images/Breakups";
import Depression from "./images/Depression";
import Drugs from "./images/Drugs";
import Eating from "./images/Eating";
import FinancialWellness from "./images/FinancialWellness";
import Grief from "./images/Grief";
import Marijuana from "./images/Marijuana";
import Nutrition from "./images/Nutrition";
import PhysicalWellness from "./images/PhysicalWellness";
import Pregnancy from "./images/Pregnancy";
import Relationship from "./images/Relationship";
import SexualHealth from "./images/SexualHealth";
import Sleep from "./images/Sleep";
import SocialAnxiety from "./images/SocialAnxiety";
import Trauma from "./images/Trauma";

const images = {
  anxiety: (props = {}) => <Anxiety {...props} viewBox="0 0 24 24" />,
  depression: (props = {}) => <Depression {...props} viewBox="0 0 24 24" />,
  pregnancy: (props = {}) => <Pregnancy {...props} viewBox="0 0 17.5 24" />,
  physical_wellness: (props = {}) => <PhysicalWellness {...props} viewBox="0 0 24 22.33" />,
  social_anxiety: (props = {}) => <SocialAnxiety {...props} viewBox="0 0 24 21.97" />,
  eating: (props = {}) => <Eating {...props} viewBox="0 0 13 24" />,
  sexual_health: (props = {}) => <SexualHealth {...props} viewBox="0 0 24 22.19" />,
  academic: (props = {}) => <Academic {...props} viewBox="0 0 24 19.76" />,
  trauma: (props = {}) => <Trauma {...props} viewBox="0 0 19.21 24" />,
  alcohol: (props = {}) => <Alcohol {...props} viewBox="0 0 20.63 24" />,
  marijuana: (props = {}) => <Marijuana {...props} viewBox="0 0 24 23.1" />,
  sleep: (props = {}) => <Sleep {...props} viewBox="0 0 20.5 24" />,
  relationship: (props = {}) => <Relationship {...props} viewBox="0 0 24 19.95" />,
  financial_wellness: (props = {}) => <FinancialWellness {...props} viewBox="0 0 24 22.24" />,
  nutrition: (props = {}) => <Nutrition {...props} viewBox="0 0 21.66 24" />,
  breakups: (props = {}) => <Breakups {...props} viewBox="0 0 24 22.33" />,
  grief: (props = {}) => <Grief {...props} viewBox="0 0 24 21.92" />,
  drugs: (props = {}) => <Drugs {...props} viewBox="0 0 24 20.89" />,
};

const WellnessIcon = ({ type, ...rest }) => {
  const Match = images[type]
  if(Match) return <Match  {...rest} />
  return false
}

export default WellnessIcon;
